import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60334125"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-tie me-2" }, null, -1))
const _hoisted_2 = { class: "row px-3" }
const _hoisted_3 = { class: "col-4 d-flex justify-content-center align-items-center" }
const _hoisted_4 = { class: "photo text-center" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-camera me-2" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_9 = { class: "col-8" }
const _hoisted_10 = { class: "px-3" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "ministerForm",
    backdrop: "static",
    onHide: _ctx.clearForm
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("input", {
              ref: "fileDialog",
              type: "file",
              class: "file-upload",
              accept: "image/*",
              disabled: _ctx.isLoading,
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fileDialogChange && _ctx.fileDialogChange(...args)))
            }, null, 40, _hoisted_5),
            _createElementVNode("img", {
              class: "photo-image",
              src: _ctx.photoPreview,
              width: "60",
              height: "70",
              alt: "preview"
            }, null, 8, _hoisted_6),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-primary btn-sm mt-2",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fileDialogClick && _ctx.fileDialogClick(...args)))
              }, [
                _hoisted_7,
                _createTextVNode("เลือกรูป ")
              ])
            ]),
            (_ctx.submited && _ctx.errors.photo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " * กรุณาเลือกรูป "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", {
                for: "prefix",
                class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.prefix}])
              }, " คำนำหน้านาม: ", 2),
              (_ctx.submited && _ctx.errors.prefix)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, " * กรุณาป้อนคำนำหน้านาม "))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.prefix) = $event)),
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.prefix}]),
                placeholder: "กรุณาป้อนคำนำหน้านาม...",
                "aria-label": "prefix",
                autocomplete: "off",
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
              }, null, 34), [
                [
                  _vModelText,
                  _ctx.formData.prefix,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", {
                for: "firstName",
                class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.firstName}])
              }, " ชื่อ ร.นรม./รมต.นร.: ", 2),
              (_ctx.submited && _ctx.errors.firstName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, " * กรุณาป้อนชื่อ ร.นรม./รมต.นร. "))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.firstName) = $event)),
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.firstName}]),
                placeholder: "กรุณาป้อนชื่อ ร.นรม./รมต.นร....",
                "aria-label": "firstName",
                autocomplete: "off",
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
              }, null, 34), [
                [
                  _vModelText,
                  _ctx.formData.firstName,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", {
                for: "lastName",
                class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.lastName}])
              }, " นามสกุล: ", 2),
              (_ctx.submited && _ctx.errors.lastName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, " * กรุณาป้อนนามสกุล "))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.lastName) = $event)),
                class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.lastName}]),
                placeholder: "กรุณาป้อนนามสกุล...",
                "aria-label": "lastName",
                autocomplete: "off",
                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
              }, null, 34), [
                [
                  _vModelText,
                  _ctx.formData.lastName,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      (_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-danger me-auto",
            disabled: _ctx.isLoading,
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.deleteClick && _ctx.deleteClick(...args)))
          }, [
            _hoisted_18,
            _createTextVNode(" ลบ ")
          ], 8, _hoisted_17))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.isLoading,
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_20,
        _createTextVNode(" ปิด ")
      ], 8, _hoisted_19),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.isLoading,
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_22,
        _createTextVNode(" บันทึก ")
      ], 8, _hoisted_21)
    ]),
    _: 1
  }, 8, ["onHide"]))
}